import { el } from "@dhx/ts-common/dom";
import { DataCollection } from "@dhx/ts-data";
import { Text } from "./Text";

export class Select extends Text {
	toVDOM() {
		const options = this._getOptions(this._config.data);

		return el(".edit-section.input_group_up", [
			el(".section-title", this._config.label),
			el(
				"select.dhx_select",
				{
					onchange: this._handlers.change,
					oninput: this._handlers.change,
				},
				options
			),
		]);
	}
	private _getOptions(data: DataCollection | any[]) {
		if (data instanceof Array) {
			const d = new DataCollection();
			d.parse(data);
			data = d;
		}
		data.add({ value: "", title: "" }, 0);
		return data.map(item => {
			const selected = item.value === this._config.value;
			return el(
				"option.dhx_option",
				{
					value: item.value,
					selected,
				},
				item.title
			);
		});
	}
}
